import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';

import StyledSkeleton from '../styled/Skeleton';

var Skeleton = function (_Component) {
  _inherits(Skeleton, _Component);

  function Skeleton() {
    _classCallCheck(this, Skeleton);

    return _possibleConstructorReturn(this, (Skeleton.__proto__ || _Object$getPrototypeOf(Skeleton)).apply(this, arguments));
  }

  _createClass(Skeleton, [{
    key: 'render',
    value: function render() {
      return React.createElement(StyledSkeleton, this.props);
    }
  }]);

  return Skeleton;
}(Component);

Skeleton.defaultProps = {
  size: 'medium',
  weight: 'normal'
};
export default Skeleton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/icon/dist/esm/components/Skeleton.js
// module id = 732
// module chunks = 0